<template>
  <b-overlay
    :show="busy"
    rounded
    opacity="0.6"
    spinner-small
    spinner-variant="primary-action"
    class="d-inline-block"
  >
    <BaseButtonComponent
      style="padding: 1px 12px;"
      @click="sendInvoice()"
      variant="primary-action"
    >
      WhatsApp
    </BaseButtonComponent>
  </b-overlay>
</template>

<script>
import { Api } from '../../../../vue/api';
import { BaseButtonComponent } from '../../../../ui/buttons';
const API = new Api();

export default {
  components: {
    BaseButtonComponent,
  },
  props: {
    month: {
      type: String,
      required: true,
      default: '',
    },
    year: {
      type: String,
      required: true,
      default: '',
    },
    installationNumber: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    /**
     * Função para enviar fatura por Whatsapp
     * @return {function(): void}
     */
    async sendInvoice() {
      this.busy = true;
      this.$bvToast.toast('Envio pelo Whatsapp não implementado!', {
        title: `Info`,
        variant: 'info',
        solid: true,
      });
      this.busy = false;
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  padding: 1px 12px;
}
</style>
